module.exports = __webpack_public_path__ + "static/media/CC20-AP090-12.ce2ee18a.png";